<template>
	<Icon v-bind="$props">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 448 512"
			class="svg-inline--fa fa-lock"
		>
			<path
				class="light"
				fill="currentColor"
				d="M96 192V128C96 57.31 153.3 0 224 0C294.7 0 352 57.31 352 128V192H368C412.2 192 448 227.8 448 272V432C448 476.2 412.2 512 368 512H80C35.82 512 0 476.2 0 432V272C0 227.8 35.82 192 80 192H96zM128 192H320V128C320 74.98 277 32 224 32C170.1 32 128 74.98 128 128V192zM32 432C32 458.5 53.49 480 80 480H368C394.5 480 416 458.5 416 432V272C416 245.5 394.5 224 368 224H80C53.49 224 32 245.5 32 272V432z"
			/>
			<path
				class="regular"
				fill="currentColor"
				d="M96 192V128C96 57.31 153.3 0 224 0C294.7 0 352 57.31 352 128V192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256C0 220.7 28.65 192 64 192H96zM144 192H304V128C304 83.82 268.2 48 224 48C179.8 48 144 83.82 144 128V192zM48 448C48 456.8 55.16 464 64 464H384C392.8 464 400 456.8 400 448V256C400 247.2 392.8 240 384 240H64C55.16 240 48 247.2 48 256V448z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'LockIcon',
	components: { Icon },
	props,
}
</script>
